import React from 'react';
import StepHeader, { ConcentricIcon } from '../StepHeader/StepHeader';
import Confetti from './Confetti';

/**
 * Hero of the last step. `ready` (with product) celebrates with a pulse and confetti;
 * `created` (no product yet) is calmer.
 */
const SuccessHero = ({ id, variant = 'ready', title, subtitle }) => {
    const ready = variant === 'ready';

    return (
        <>
            {ready && <Confetti />}
            <StepHeader
                id={id}
                center
                display
                title={title}
                subtitle={subtitle}
                icon={
                    <ConcentricIcon
                        icon={ready ? 'ri-check-line' : 'ri-store-2-fill'}
                        size={ready ? 112 : 88}
                        celebrate={ready}
                    />
                }
            />
        </>
    );
};

export default SuccessHero;
